import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SubservientChargesMcaUI from '../../../components/superUser/clientData/SubservientChargesMcaUI'
import SubservientChargesItrUI from '../../../components/superUser/clientData/SubservientChargesItrUI'
import ChargeValueMcaUI from '../../../components/superUser/clientData/ChargeValueMcaUI'
import ChargeValueItrUI from '../../../components/superUser/clientData/ChargeValueItrUI'

const CalculationsPageUI = ({ context, account, subservientMCA, subservientITR, chargeValueMCA, chargeValueITR,
  toggleEditable, editable, onDetailsClick, details, onShowDetailsClick, showDetails, onRefreshClick }) =>
  <SuperUserAccountPageUI context={context} className='pg_su_cal' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!subservientMCA || !subservientITR}
    account={account} page='clientData' dimension='w768'
  >
    {
      (!subservientMCA || !subservientITR) &&
      <SpinnerComponentUI />
    }
    {
      subservientMCA && subservientITR &&
      <div>
        <CalculationsUI
          context={context}
          onRefreshClick={onRefreshClick}
        />

        {
          account &&
          <ClientDataNavUI account={account} page='calculations' />
        }

        <div className='g_flex_h g_flex_left g_flex_wrap nav'>
          <a className='w_tab' href='#subservientMca'>Subservient using MCA</a>
          <a className='w_tab' href='#subservientItr'>Subservient using ITR</a>
          <a className='w_tab' href='#chargeValueMca'>Charge Value using MCA</a>
          <a className='w_tab' href='#chargeValueItr'>Charge Value using ITR</a>
        </div>

        <SubservientChargesMcaUI context={context} account={account} subservientMCA={subservientMCA} onShowDetailsClick={onShowDetailsClick} showDetails={showDetails} />
        <SubservientChargesItrUI context={context} account={account} subservientITR={subservientITR} onShowDetailsClick={onShowDetailsClick} showDetails={showDetails} />
        <ChargeValueMcaUI chargeValueMCA={chargeValueMCA} toggleEditable={toggleEditable} editable={editable} />
        <ChargeValueItrUI chargeValueITR={chargeValueITR} onDetailsClick={onDetailsClick} details={details} />
      </div>
    }
  </SuperUserAccountPageUI>

const CalculationsUI = ({ context, onRefreshClick }) =>
  <div>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Client Data - Calculations</b></span>
        </div>
      }
      right={<span />}
    />
  </div>

export default CalculationsPageUI
